import MyLeavesView from "../../features/leave/MyLeavesView";

const MyLeavesPage = () => <MyLeavesView />;

export default MyLeavesPage;
